import React from 'react';

import {
	Person,
	CorporateFare,
	ArticleOutlined,
	Groups,
} from '@mui/icons-material';

import {
	DoubleLocationIcon,
	HeadCountIcon,
	HospitalIcon,
	MoneyIcon,
} from '@ivy/components/icons';
import { gql, type FragmentType, getFragmentData } from '@ivy/gql/types';
import AcepTableSection, {
	type AcepTableSectionProps,
} from '@ivy/views/org/OrgShow/OrgProfile/AcepTableSection';

const AcepCharacteristics_OrgFDoc = gql(/* GraphQL */ `
	fragment AcepCharacteristics_Org on organization {
		id
		surveys: acep_org_surveys(
			where: { accepted_at: { _is_null: false } }
			order_by: [{ accepted_at: desc_nulls_last }]
			limit: 1
		) {
			id
			staffing
			numEmPhysicians: num_em_physicians
			practiceSize: practice_size
			geographicDist: geographic_dist
			contractOwner: contract_owner
			governance
			ceoIsPhysician: ceo_is_physician
			funding
		}
	}
`);

export interface AcepCharacteristicsProps
	extends Omit<AcepTableSectionProps, 'title' | 'items'> {
	org: FragmentType<typeof AcepCharacteristics_OrgFDoc>;
}

const AcepCharacteristics = ({
	org: rawOrg,
	...props
}: AcepCharacteristicsProps) => {
	const org = getFragmentData(AcepCharacteristics_OrgFDoc, rawOrg);

	const survey = org.surveys[0];

	return (
		<AcepTableSection
			items={
				!survey
					? undefined
					: [
							{
								icon: <CorporateFare />,
								label: 'Staffing model',
								value: survey.staffing.join(',\n'),
							},
							{
								icon: <HeadCountIcon />,
								label: 'Number of EM Physicians',
								value: `${survey.numEmPhysicians}`,
							},
							{
								icon: <HospitalIcon />,
								label: 'Practice Size',
								value: survey.practiceSize,
							},
							{
								icon: <DoubleLocationIcon />,
								label: 'Geographic Distribution',
								value: survey.geographicDist,
							},
							{
								icon: <ArticleOutlined />,
								label: 'Contract Ownership',
								value: survey.contractOwner.join(',\n'),
							},
							{
								icon: <Groups />,
								label: 'Group Governance',
								value: survey.governance.join(',\n'),
							},
							{
								icon: <Person />,
								label: 'Physician CEO',
								value: survey.ceoIsPhysician,
							},
							{
								icon: <MoneyIcon />,
								label: 'Funding',
								value: survey.funding.join(',\n'),
							},
					  ]
			}
			title='Group Characteristics'
			{...props}
		/>
	);
};

export default AcepCharacteristics;
